import { TicketSource } from '@sb-tools/typescript/enums/ticket-source.enum';

// needed for usages in logic files, where we can't use pipe TicketSourcePipe

export function getSourceNameUtil(source: number) {
    switch (source) {
        case TicketSource.form:
            return 'form';
        case TicketSource.email:
            return 'email';
        case TicketSource.chat:
            return 'chat';
        case TicketSource.facebook:
            return 'facebook';
        case TicketSource.instagram:
            return 'instagram';
        case TicketSource.youtube:
            return 'youtube';
        case TicketSource.googleMyBusiness:
            return 'googleMyBusiness';
        case TicketSource.trustpilot:
            return 'trustpilot';
        case TicketSource.googlePlayMarket:
            return 'googlePlayMarket';
        case TicketSource.appStore:
            return 'app-store';
        case TicketSource.whatsApp:
            return 'whats-app';
        case TicketSource.tikTok:
            return 'tiktok';
        case TicketSource.api:
            return 'api';
        default:
            return false;
    }
}
